import React from 'react';
import { Box, Text, VStack, Icon, Button } from '@chakra-ui/react';
import { FaLock } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import authService from 'services/authService';

const ProtectedRoute = ({ 
  children, 
  requiredPermissions = [], 
  requiredRole = null,
  excludeRoles = [],
  requireAny = false // Si es true, solo necesita uno de los permisos; si es false, necesita todos
}) => {
  const navigate = useNavigate();

  // Función para verificar rol directamente desde localStorage
  const verifyRoleFromStorage = (role) => {
    try {
      const userData = localStorage.getItem('userData');
      if (!userData) return false;
      
      const user = JSON.parse(userData);
      return user.role === role || user.role === 'Admin';
    } catch (error) {
      console.error('Error verificando rol desde storage:', error);
      return false;
    }
  };

  // Verificar si el usuario está autenticado
  const userData = localStorage.getItem('userData');
  if (!userData) {
    return (
      <Box 
        display="flex" 
        justifyContent="center" 
        alignItems="center" 
        minHeight="400px"
        textAlign="center"
      >
        <VStack spacing={4}>
          <Icon as={FaLock} boxSize={12} color="red.500" />
          <Text fontSize="xl" fontWeight="bold" color="red.500">
            Acceso Denegado
          </Text>
          <Text color="gray.600">
            Debes iniciar sesión para acceder a esta página
          </Text>
          <Button 
            colorScheme="gray" 
            onClick={() => navigate('/auth/sign-in')}
          >
            Iniciar Sesión
          </Button>
        </VStack>
      </Box>
    );
  }

  if (
    excludeRoles.some((role) => role === 'Mecanico' && authService.isMechanic())
  ) {
    return (
      <Box 
        display="flex" 
        justifyContent="center" 
        alignItems="center" 
        minHeight="400px"
        textAlign="center"
      >
        <VStack spacing={4}>
          <Icon as={FaLock} boxSize={12} color="red.500" />
          <Text fontSize="xl" fontWeight="bold" color="red.500">
            Acceso Denegado
          </Text>
          <Text color="gray.600">
            No tienes acceso a esta página
          </Text>
        </VStack>
      </Box>
    );
  }

  // Verificar rol específico si se requiere
  if (requiredRole && !verifyRoleFromStorage(requiredRole)) {
    return (
      <Box 
        display="flex" 
        justifyContent="center" 
        alignItems="center" 
        minHeight="400px"
        textAlign="center"
      >
        <VStack spacing={4}>
          <Icon as={FaLock} boxSize={12} color="red.500" />
          <Text fontSize="xl" fontWeight="bold" color="red.500">
            Acceso Denegado
          </Text>
          <Text color="gray.600">
            No tienes el rol necesario para acceder a esta página
          </Text>
          <Text fontSize="sm" color="gray.500">
            Rol requerido: {requiredRole}
          </Text>
        </VStack>
      </Box>
    );
  }

  // Verificar permisos si se especifican
  if (requiredPermissions.length > 0) {
    console.log('=== PROTECTED ROUTE CHECKING PERMISSIONS ===');
    console.log('Required permissions:', requiredPermissions);
    console.log('Require any (or all):', requireAny);
    
    const hasPermission = authService.constructor.checkMultiplePermissions(
      requiredPermissions, 
      !requireAny, // requireAll es lo opuesto a requireAny
      true // fromStorage = true
    );
    
    console.log('Has required permissions:', hasPermission);

    if (!hasPermission) {
      return (
        <Box 
          display="flex" 
          justifyContent="center" 
          alignItems="center" 
          minHeight="400px"
          textAlign="center"
        >
          <VStack spacing={4}>
            <Icon as={FaLock} boxSize={12} color="red.500" />
            <Text fontSize="xl" fontWeight="bold" color="red.500">
              Acceso Denegado
            </Text>
            <Text color="gray.600">
              No tienes los permisos necesarios para acceder a esta página
            </Text>
            <Text fontSize="sm" color="gray.500">
              Permisos requeridos: {requiredPermissions.join(', ')}
            </Text>
          </VStack>
        </Box>
      );
    }
  }

  // Si pasa todas las verificaciones, renderizar el componente
  return children;
};

export default ProtectedRoute;